import Immutable from 'immutable';
import createReducer from 'common/redux/utils/createReducer';
import { RECEIVE_TIP } from 'tip/actions/tip';
import { REMOVE_CHAPTER } from 'tip/actions/chapters';
import { REMOVE_PARAGRAPH } from 'tip/actions/paragraphs';

const initialState = {
  chapters: Immutable.List(),
  paragraphs: Immutable.List(),
};

const history = createReducer(initialState, {
  [REMOVE_CHAPTER](state, { chapter }) {
    if (chapter.new) {
      return state;
    }

    return {
      ...state,
      chapters: state.chapters.push(chapter.id),
    };
  },

  [REMOVE_PARAGRAPH](state, { paragraph }) {
    if (paragraph.new) {
      return state;
    }

    return {
      ...state,
      paragraphs: state.paragraphs.push(paragraph.id),
    };
  },
  [RECEIVE_TIP](state) {
    return initialState;
  },
});

export default history;



// WEBPACK FOOTER //
// ./src/modules/tip/reducers/history.js